import { combineReducers } from 'redux';

import { profileRepositoriesReducer as repositories } from './repositories';
import { profileRepositoriesLanguagesReducer as repositoriesLanguages } from './repositories/languages';
import { sectionReducer as section } from './section';

export const profileReducer = combineReducers({
  repositories,
  repositoriesLanguages,
  section,
});
